<template>
    <div>
        <v-card elevation="0" class="contact-card">
            <v-card-title><v-icon>mdi-phone</v-icon>&nbsp;Contacts &#38; Useful Links</v-card-title>
            <v-card-text>
                <v-card elevation="0" color="white">
                    <v-card-subtitle class="black--text text-h6">Human Resources</v-card-subtitle>
                    <v-card-text>
                        <v-icon small>mdi-email</v-icon> : HR@kings.uwo.ca <br />
                        <v-icon small>mdi-phone</v-icon> : 519-433-3491
                    </v-card-text>
                    <!-- <v-card-subtitle class="black--text text-h6">Academic Dean's Office</v-card-subtitle>
                    <v-card-text>
                        <v-icon small>mdi-link</v-icon> : <a href="https://mykings.ca/intranet/app/#/academics/academic-advising/meet-the-academic-advising-team" target="_blank">Contacts</a>
                    </v-card-text> -->
                    <v-card-subtitle class="black--text text-h6">Links</v-card-subtitle>
                    <v-card-text>
                        <v-icon small>mdi-file-document-multiple-outline</v-icon> : <a href="https://kings.uwo.ca/sites/2025/assets/files/about/HR/CA-L5265-Kings-University-College-Expiring-2027.pdf" target="_blank">CUPE Collective Agreement</a> <br />
                        <!-- <v-icon small>mdi-information-variant-box-outline</v-icon> : <a href="https://www.kings.uwo.ca/about-kings/facts-and-information/administrative-departments/hr/careers/part-time-faculty-appointments/" target="_blank">Part-Time Faculty Appointments</a> <br /> -->
                        <v-icon small>mdi-shield-crown-outline</v-icon> : <a href="https://mykings.ca/" target="_blank">MyKing's</a> <br />
                        <v-icon small>mdi-office-building-outline</v-icon> : <a href="https://www.kings.uwo.ca/about/human-resources/" target="_blank">King's Human Resources</a> <br />
                        <v-icon small>mdi-calendar-blank-outline</v-icon> : <a href="https://www.westerncalendar.uwo.ca/Courses.cfm?SelectedCalendar=Live&ArchiveID=" target="_blank">Academic Calendar</a><br />
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.contact-card{
    background-color: rgba(215,174,40,0.3);
}
</style>